import type {AsyncNamespace, OttoNexus} from "@otto-ec/global-resources/nexus";
import type {SharingRaw} from "./sharing"
import type {GlobalRaw} from "./global";
import type {PushNotificationsRaw} from "./pushnotifications";
import type {CookieBannerRaw} from "./cookiebanner";
import type {HapticFeedbackRaw} from "./hapticfeedback";
import type {ThirdpartyTrackingRaw} from "./thirdpartytracking";
import type {UserMediaRaw} from "./usermedia";
import type { MediaRaw } from "./media";

declare global {
    interface NexusInterfaces {
        /**
 *
 */
        apps: {
            cookieBanner: AsyncNamespace<CookieBannerRaw>
            global: AsyncNamespace<GlobalRaw>,
            hapticFeedback: AsyncNamespace<HapticFeedbackRaw>,
            userMedia: AsyncNamespace<UserMediaRaw>,
            pushNotifications: AsyncNamespace<PushNotificationsRaw>,
            sharing: AsyncNamespace<SharingRaw>,
            thirdpartyTracking: AsyncNamespace<ThirdpartyTrackingRaw>,
            media: AsyncNamespace<MediaRaw>,
        }
    }
}

export type apps = OttoNexus["apps"]

export const apps: OttoNexus["apps"] = otto.apps